module.exports = __webpack_public_path__ + "static/default-header-05809b6f606b3d837ffa485620ac2fee.jpg";